import React from 'react';
import { BrowserRouter as Router , Switch, Route } from 'react-router-dom';
import Footer from './Atoms/Footer/Footer';
// import Header from './Atoms/Header/Header';
import Home from './Pages/Home/Home';
import Menu1 from './Pages/Menu1/Menu1';
import Menu2 from './Pages/Menu2/Menu2';
import Preferences from './Pages/Preferences/Preferences';
import Sidebar from './Atoms/Sidebar/Sidebar';
import './Styles/App.scss';

const App = () => {
  return (
    <Router>
      {/*<Header />*/}
      <Sidebar />
      <div className='page-container'>
        <Switch>
          <Route exact path='/' component={Home} />
          <Route path='/brewery' component={Menu1} />
          <Route path='/oyashima' component={Menu2} />
          <Route path='/preferencias' component={Preferences}/>
        </Switch>
      </div>
      <Footer />
    </Router>
  );
};
export default App;